'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Tooltip;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./tooltip.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Tooltip Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function Tooltip(props) {
    var _cx;

    var _props$style = props.style,
        style = _props$style === undefined ? '' : _props$style,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$position = props.position,
        position = _props$position === undefined ? '' : _props$position,
        isVisible = props.isVisible,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-tooltip': true,
        'sb-tooltip--visible': isVisible
    }, (0, _defineProperty3.default)(_cx, 'sb-tooltip--' + style, style), (0, _defineProperty3.default)(_cx, 'sb-tooltip--' + position, position), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('div', {
        className: classNames,
        id: id
    }, void 0, props.children);
}
// css
//# sourceMappingURL=Tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/tooltip/Tooltip.js
// module id = 622
// module chunks = 0